export default "__VITE_ASSET__oLR0gcFo__"